import AddTags from './AddTags'

export default AddTags
